import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './src/ui/__generated__/GlobalPermissionsPageQuery.graphql';

export const globalPermissionsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-global-permissions" */ './src/ui/GlobalPermissionsPage.tsx'
			),
	),
	getPreloadProps: ({ tenantContext: { cloudId } }: EntryPointRouteParams) => ({
		queries: {
			globalPermissionsPageQuery: {
				parameters,
				variables: {
					cloudId,
				},
			},
		},
	}),
});
